// extracted by mini-css-extract-plugin
export default {"container":"CTAComponent__container___Uw9f9","heading":"CTAComponent__heading___JIybj","button":"CTAComponent__button___p_ayR"};